import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSetPositionPercent = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "height",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_4",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_4)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "height_2",
				d: "M12 21L8 17L9.4 15.6L11 17.175V6.825L9.4 8.4L8 7L12 3L16 7L14.6 8.425L13 6.825V17.175L14.6 15.6L16 17L12 21Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgSetPositionPercent;
